// extracted by mini-css-extract-plugin
module.exports = {"switch":"cd01fbf7b5--switch--WlT9Z","indicator":"cd01fbf7b5--indicator--qrsk6","label":"cd01fbf7b5--label--L_Whq"};